/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};
  var Utils = window.OletLens.Utils || {};

  function notifyColorReset() {
    var message =
      'Your selected Photochromic color is not available for this lens type. Please choose Gray or Brown.';
    if (window.Toastify) {
      window
        .Toastify({
          text: message,
          duration: 4000,
          close: true,
          gravity: 'top',
          position: 'right',
          style: { backgroundColor: '#009AD6' },
        })
        .showToast();
    }
  }

  function getAllowedPhotochromicColors(usageType, lensType) {
    if (Utils.getPhotochromicAllowedColors) {
      return Utils.getPhotochromicAllowedColors(usageType, lensType);
    }
    return ['gray', 'brown', 'green', 'blue', 'pink', 'yellow'];
  }

  function isColorAllowedForPhotochromic(color, usageType, lensType) {
    if (Utils.isPhotochromicColorAllowed) {
      return Utils.isPhotochromicColorAllowed(color, usageType, lensType);
    }
    return getAllowedPhotochromicColors(usageType, lensType).indexOf(color) !== -1;
  }

  function resetPhotochromicColorSelection(photochromicEl, app, notify) {
    if (!photochromicEl) return false;

    var selected = photochromicEl.querySelector('.color-select.selected-color');
    if (!selected) return false;

    selected.classList.remove('selected-color');
    var colorLabel = photochromicEl.querySelector('.selected-color-name');
    if (colorLabel) colorLabel.textContent = 'Select color:';

    if (app && typeof app.setState === 'function') {
      var activeType = normalizeSunglassesType(photochromicEl.getAttribute('sunglasses-type'));
      var currentSun = app.state && app.state.sunglasses ? normalizeSunglassesType(app.state.sunglasses) : null;
      if (currentSun === activeType || photochromicEl.classList.contains('active')) {
        app.setState('sunglassesColor', null);
      }
    }

    if (notify) notifyColorReset();
    return true;
  }

  function updatePhotochromicColors(usageType, lensType, app) {
    var photochromicEl = document.querySelector('.sunglasses-upgrade[sunglasses-type="photochromic"]');
    if (!photochromicEl) return;

    var allowed = getAllowedPhotochromicColors(usageType, lensType);
    var selectedColorEl = photochromicEl.querySelector('.color-select.selected-color');
    var selectedColor = selectedColorEl ? selectedColorEl.getAttribute('data-color') : null;
    var needsReset = false;

    photochromicEl.querySelectorAll('.color-select').forEach(function (colorEl) {
      var color = colorEl.getAttribute('data-color');
      var isAllowed = allowed.indexOf(color) !== -1;
      colorEl.style.display = isAllowed ? '' : 'none';
      colorEl.setAttribute('aria-hidden', isAllowed ? 'false' : 'true');
      if (!isAllowed && colorEl.classList.contains('selected-color')) {
        needsReset = true;
      }
    });

    if (needsReset || (selectedColor && !isColorAllowedForPhotochromic(selectedColor, usageType, lensType))) {
      resetPhotochromicColorSelection(photochromicEl, app, true);
    }
  }

  function normalizeSunglassesType(type) {
    if (type === 'photochromic_polarized_sunglasses') return 'photochromic_polarized';
    return type;
  }

  function getSelection() {
    var active = document.querySelector('.sunglasses-upgrade.active');
    if (!active) return null;
    var type = normalizeSunglassesType(active.getAttribute('sunglasses-type'));
    var selectedColor = active.querySelector('.color-select.selected-color');
    var color = selectedColor ? selectedColor.getAttribute('data-color') : null;
    return { type: type, color: color };
  }

  function validate(usageType, lensType) {
    var sel = getSelection();
    if (!sel) return { valid: true, errors: [] };
    if (!sel.color) return { valid: false, errors: ['Please select a color for your sunglasses.'] };
    if (
      sel.type === 'photochromic' &&
      !isColorAllowedForPhotochromic(sel.color, usageType, lensType)
    ) {
      return {
        valid: false,
        errors: ['Please choose Gray or Brown for Photochromic Sunglasses with your selected lens type.'],
      };
    }
    return { valid: true, errors: [] };
  }

  function clearSelection(app, options) {
    var skipCalculate = options && options.skipCalculate;
    var all = document.querySelectorAll('.sunglasses-upgrade');
    all.forEach(function (el) {
      el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      el.querySelectorAll('.color-select').forEach(function (c) {
        c.classList.remove('selected-color');
      });
      var colorLabel = el.querySelector('.selected-color-name');
      if (colorLabel) colorLabel.textContent = 'Select color:';
    });
    if (app && typeof app.setState === 'function') {
      app.setState('sunglasses', null);
      app.setState('sunglassesColor', null);
      app.setState('sunglassesPrice', 0);
      if (!skipCalculate && typeof app.calculateTotalPrice === 'function') {
        app.calculateTotalPrice();
      }
    }
  }

  function handleSelection(element, app) {
    var alreadyActive = element.classList.contains('active');
    var all = document.querySelectorAll('.sunglasses-upgrade');

    all.forEach(function (el) {
      el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      el.querySelectorAll('.color-select').forEach(function (c) {
        c.classList.remove('selected-color');
      });
    });

    if (!alreadyActive) {
      element.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      var colorLabel = element.querySelector('.selected-color-name');
      if (colorLabel) colorLabel.textContent = 'Select color:';
    }

    if (app && typeof app.setState === 'function') {
      var selection = getSelection();
      app.setState('sunglasses', selection ? selection.type : null);
      app.setState('sunglassesColor', selection ? selection.color : null);

      var price = 0;
      if (selection) {
        price = parseFloat(element.getAttribute('option-price')) || 0;
      }
      app.setState('sunglassesPrice', price);
      app.calculateTotalPrice();
    }
  }

  function handleColorSelection(element, app) {
    var parent = element.closest('.sunglasses-upgrade');
    if (!parent) return;

    var colorName = element.getAttribute('data-color');
    var sunType = normalizeSunglassesType(parent.getAttribute('sunglasses-type'));
    if (sunType === 'photochromic' && app && app.state) {
      var usageType = app.state.usage;
      var lensType = app.state.lensType;
      if (!isColorAllowedForPhotochromic(colorName, usageType, lensType)) {
        return;
      }
    }

    parent.querySelectorAll('.color-select').forEach(function (opt) {
      opt.classList.remove('selected-color');
    });
    element.classList.add('selected-color');
    var colorLabel = parent.querySelector('.selected-color-name');
    if (colorLabel) {
      colorLabel.textContent = 'Selected: ' + (colorName ? colorName.charAt(0).toUpperCase() + colorName.slice(1) : '');
    }

    if (!parent.classList.contains('active')) {
      handleSelection(parent, app);
    }

    if (app && typeof app.setState === 'function') {
      app.setState('sunglassesColor', colorName);
    }
  }

  function updateOptions(usageType, lensType, app) {
    var bifocalIncompatible = (Config.ADDON_RULES && Config.ADDON_RULES.bifocal_incompatible) || [];
    var isBifocal = usageType === 'bifocals';
    var all = document.querySelectorAll('.sunglasses-upgrade');

    all.forEach(function (el) {
      var type = normalizeSunglassesType(el.getAttribute('sunglasses-type'));
      if (isBifocal && bifocalIncompatible.indexOf(type) !== -1) {
        el.style.display = 'none';
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      } else {
        el.style.display = '';
      }
    });

    updatePhotochromicColors(usageType, lensType, app);
  }

  function init(app) {
    var upgrades = document.querySelectorAll('.sunglasses-upgrade');
    upgrades.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.color-select')) return;
        handleSelection(el, app);
      });
      var colors = el.querySelectorAll('.color-select');
      colors.forEach(function (colorEl) {
        colorEl.addEventListener('click', function (e) {
          e.stopPropagation();
          handleColorSelection(colorEl, app);
        });
      });
    });
  }

  window.OletLens.SunglassesModule = {
    init: init,
    handleSelection: handleSelection,
    handleColorSelection: handleColorSelection,
    getSelection: getSelection,
    validate: validate,
    updateOptions: updateOptions,
    updatePhotochromicColors: updatePhotochromicColors,
    clearSelection: clearSelection,
  };
})();
